<template>
  <main id="create-client-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <form
      class="create-client-form"
      @submit.prevent="onCreateClient"
      novalidate
    >
      <!-- RIGA 1 -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci il nome del cliente..."
          />
        </div>

        <div class="field">
          <label for="fiscal-code">Codice fiscale</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
          />
        </div>
      </div>

      <!-- RIGA 2: telefono + recapito -->
      <div class="create-client-row row-2">
        <div class="field">
          <label for="phone">Telefono</label>
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
          />
        </div>

        <div class="contact-right-group">
          <div class="field contact-selector">
            <label>Recapito preferito</label>
            <StatusSelect v-model="contactChoice" :options="contactOptions" />
          </div>

          <div class="field" v-if="contactChoice === 'pec'">
            <label for="pec">PEC</label>
            <input
              id="pec"
              type="email"
              v-model="formData.pec"
              required
              placeholder="inserisci l'indirizzo PEC..."
            />
          </div>

          <div class="field" v-if="contactChoice === 'email'">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              v-model="formData.email"
              required
              placeholder="inserisci l'indirizzo email..."
            />
          </div>
        </div>
      </div>

      <hr />

      <!-- RIGA 3: ragione sociale + p.iva -->
      <div class="create-client-row row-3">
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci la ragione sociale..."
            required
          />
        </div>

        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci la partita IVA..."
          />
        </div>
      </div>

      <!-- RIGA 4: codice univoco + sede legale -->
      <div class="create-client-row row-4">
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci il codice univoco..."
          />
        </div>

        <!-- Sede legale (inserimento manuale) -->
        <div class="field">
          <label for="lh-address">Sede legale</label>
          <input
            id="lh-address"
            type="text"
            v-model="formData.legalHeadquarters.address"
            placeholder="Inserisci indirizzo completo…"
            autocomplete="off"
          />
        </div>
      </div>

      <hr />

      <div class="save-button-container">
        <button
          id="create-client-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :title="!canSave ? 'Compila i campi obbligatori' : 'Crea cliente'"
        >
          Salva
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import StatusSelect from "@/components/StatusSelect.vue";

export default {
  name: "CreateClientPage",
  components: { StatusSelect },
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login") {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,

      contactChoice: "",
      contactOptions: [
        { value: "pec", label: "PEC", icon: "fa-shield-halved" },
        { value: "email", label: "Email", icon: "fa-envelope" },
      ],

      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        pec: "",
        email: "",
        legalHeadquarters: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
          link: "",
        },
      },
      errorMessage: "",
      successMessage: "",
    };
  },
  computed: {
    // valida che la sede legale sia stata inserita (testo libero)
    isLegalAddressValid() {
      return !!(this.formData.legalHeadquarters?.address || "").trim();
    },
    canSave() {
      const hasContact =
        (this.contactChoice === "pec" && !!this.formData.pec) ||
        (this.contactChoice === "email" && !!this.formData.email);
      return (
        !!this.formData.companyName && hasContact && this.isLegalAddressValid
      );
    },
  },
  watch: {
    contactChoice(newVal) {
      if (newVal === "pec") this.formData.email = "";
      if (newVal === "email") this.formData.pec = "";
    },
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    ...mapActions(["createClient"]),

    resetLH() {
      this.formData.legalHeadquarters = {
        name: "",
        address: "",
        placeId: "",
        latitude: "",
        longitude: "",
        link: "",
      };
    },

    // ---- Submit ----
    async onCreateClient() {
      try {
        this.successMessage = "";
        this.errorMessage = "";

        if (!this.contactChoice) {
          this.$toast.error("Devi selezionare un metodo di contatto.");
          return;
        }
        if (this.contactChoice === "pec" && !this.formData.pec) {
          this.$toast.error("Il campo PEC è obbligatorio.");
          return;
        }
        if (this.contactChoice === "email" && !this.formData.email) {
          this.$toast.error("Il campo Email è obbligatorio.");
          return;
        }
        if (!this.isLegalAddressValid) {
          this.$toast.error("Inserisci la sede legale.");
          return;
        }

        // payload: JSON diretto, niente stringify
        const payload = { ...this.formData };
        if (this.contactChoice === "pec") delete payload.email;
        if (this.contactChoice === "email") delete payload.pec;

        const response = await this.$store.dispatch("createClient", payload);

        if (response.status === 200 || response.status === 201) {
          this.$toast.success(
            response.data?.message || "Cliente creato con successo!"
          );

          // reset form
          this.contactChoice = "";
          this.formData = {
            clientName: "",
            taxCode: "",
            phoneNumber: "",
            uniqueCode: "",
            companyName: "",
            vatNumber: "",
            pec: "",
            email: "",
            legalHeadquarters: {
              name: "",
              address: "",
              placeId: "",
              latitude: "",
              longitude: "",
              link: "",
            },
          };
          this.resetLH();

          setTimeout(() => {
            this.navigationConfirmed = true;
            this.$router.push({ name: "customers" });
          }, 800);
        }
      } catch (error) {
        if (error.response?.status === 409) {
          this.$toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Ragione sociale' già presente."
          );
        } else {
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante la creazione del cliente."
          );
        }
      }
    },
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
